module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAMhJREFUKBWFkjsOwjAQRCNuxwkQBSAKoElBJH49UISzwQE4BOICCPMcY7KeGLA0sT37xo42KZxzC3RGVfFnwIzRBe0KHk8Ux/pbFmAWIT/74NIarDthvKkwh+YCD0thE2/Gn0sthAyg4SGBvoROkU9mIA3b3DGBdQM5QA+bYF0q11OD/S3j3TNea3Fy0nK5tdPtJgmkLS/xRj/DFLXln0ZQW0k4fCrMiRTq9uXDirqGK//n2JF+XHMCUBL2wS26or3hskuY6s3WL4iSoDc+r+rxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.png
// module id = q6r7
// module chunks = 1